import _JSXStyle from "styled-jsx/style";
import { requiredIf } from '@dhis2/prop-types';
import { colors } from '@dhis2/ui-constants';
import PropTypes from 'prop-types';
import React from 'react';
import i18n from '../../locales/index.js';
import { TableHeaderCellAction } from '../table-elements/index.js';
export const ASC = 'asc';
export const DESC = 'desc';
export const DEFAULT = 'default';
export const SORT_DIRECTIONS = [DEFAULT, ASC, DESC];
export const getNextSortDirection = currentDirection => {
  const currentIndex = SORT_DIRECTIONS.indexOf(currentDirection);
  const nextIndex = (currentIndex + 1) % SORT_DIRECTIONS.length;
  return SORT_DIRECTIONS[nextIndex];
};
export const Sorter = _ref => {
  let {
    name,
    sortDirection,
    title,
    onClick
  } = _ref;
  const nextSortDirection = getNextSortDirection(sortDirection);
  const clickHandler = onClick ? event => {
    onClick({
      name,
      direction: nextSortDirection
    }, event);
  } : undefined;
  return /*#__PURE__*/React.createElement(TableHeaderCellAction, {
    onClick: clickHandler,
    title: title || i18n.t('Sort items')
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    className: _JSXStyle.dynamic([["884818973", [colors.grey500, colors.blue700]]]) + " " + (sortDirection || "")
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    className: _JSXStyle.dynamic([["884818973", [colors.grey500, colors.blue700]]])
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "4 9 12 9 8 14",
    className: _JSXStyle.dynamic([["884818973", [colors.grey500, colors.blue700]]]) + " " + "top"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "4 7 12 7 8 2",
    className: _JSXStyle.dynamic([["884818973", [colors.grey500, colors.blue700]]]) + " " + "bottom"
  }))), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "884818973",
    dynamic: [colors.grey500, colors.blue700]
  }, ["svg.__jsx-style-dynamic-selector .top.__jsx-style-dynamic-selector,svg.__jsx-style-dynamic-selector .bottom.__jsx-style-dynamic-selector{fill:".concat(colors.grey500, ";}"), "svg.asc.__jsx-style-dynamic-selector .top.__jsx-style-dynamic-selector,svg.desc.__jsx-style-dynamic-selector .bottom.__jsx-style-dynamic-selector{fill:".concat(colors.blue700, ";}")]));
};
Sorter.propTypes = {
  name: PropTypes.string,
  sortDirection: requiredIf(props => props.onClick, PropTypes.oneOf(SORT_DIRECTIONS)),
  title: PropTypes.string,
  onClick: PropTypes.func
};